import React from "react";
import ReusableList from "../ui/ReusableList";

export default function ReportList({ reports, user }) {
  return <ReusableList data={reports} user={user} />;
}
